import { axiosClient } from '@/shared/apis/config';
import { DtoAccountConsent } from '@/shared/constants';
import { BaseResponse, ErrorResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { z } from 'zod';

export const patchAccountConsentFormSchema = z.object({
  consentType: z.nativeEnum(DtoAccountConsent),
  agreed: z.boolean(),
});

export type PatchAccountConsentForm = z.infer<
  typeof patchAccountConsentFormSchema
>;

/* 계정 동의 수정 */
export const patchAccountConsentApi = async (form: PatchAccountConsentForm) => {
  const response = await axiosClient.patch<BaseResponse>(
    '/v1.0/account/consent',
    form,
  );
  return response.data;
};

export const QueryKeyUsePatchAccountConsent = 'patchAccountConsent' as const;

export const usePatchAccountConsentApi = () => {
  return useMutation<
    BaseResponse,
    AxiosError<ErrorResponse>,
    PatchAccountConsentForm
  >({
    mutationFn: patchAccountConsentApi,
  });
};
